import React, { MouseEvent } from 'react';

interface Props {
  className?: string;
  onClick?: (event: MouseEvent<Element>) => void;
}

const CloseCircleIcon = ({ className, onClick }: Props) => {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="31" height="31" viewBox="0 0 31 31" className={className} onClick={onClick}>
      <g fill="none" fillRule="evenodd" stroke="none" strokeWidth="1">
        <g fill="#000" fillRule="nonzero">
          <path d="M15.36 0C6.87 0 0 6.87 0 15.36c0 8.49 6.87 15.36 15.36 15.36 8.49 0 15.36-6.87 15.36-15.36C30.72 6.87 23.85 0 15.36 0zm0 28.32c-7.163 0-12.96-5.796-12.96-12.96C2.4 8.197 8.196 2.4 15.36 2.4c7.163 0 12.96 5.796 12.96 12.96 0 7.163-5.796 12.96-12.96 12.96z"></path>
          <path d="M20.615 18.918l-3.558-3.558 3.558-3.558a1.2 1.2 0 00-1.697-1.697l-3.558 3.558-3.558-3.558a1.2 1.2 0 10-1.697 1.697l3.558 3.558-3.558 3.558a1.2 1.2 0 101.697 1.697l3.558-3.558 3.558 3.558a1.2 1.2 0 101.697-1.697z"></path>
        </g>
      </g>
    </svg>
  );
};

export default CloseCircleIcon;
